(function () {
    function getContainerOffset() {
        var w = window.innerWidth;
        if (w <= 749) return 16;
        if (w <= 989) return 32;
        var maxW = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--container-max-width')) || 1536;
        if (w >= maxW) return (w - maxW) / 2 + 48;
        return 48;
    }

    function updateProgressBar(swiperInstance, progressBar) {
        if (!progressBar) return;
        var progress = swiperInstance.progress;
        if (isNaN(progress)) progress = 0;
        var thumbRatio = Math.min(1, swiperInstance.size / swiperInstance.virtualSize);
        var thumbWidth = Math.max(thumbRatio * 100, 10);
        var maxTranslate = 100 - thumbWidth;
        var translateX = progress * maxTranslate;

        progressBar.style.width = thumbWidth + '%';
        progressBar.style.transform = 'translateX(' + (translateX / thumbWidth) * 100 + '%)';
    }

    window.ETSwiper = {
        getContainerOffset: getContainerOffset,
        updateProgressBar: updateProgressBar
    };
})();
